/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useRef, useEffect } from "react";
import { ThemeContext } from "../../pages/qcast-logo";
import { IoAdd, IoArrowBack, IoPause, IoPlay } from "react-icons/io5";
import { useSelector } from "react-redux";
import { ControlBar, Player } from "video-react";
import { useDispatch } from "react-redux";
import getBlobDuration from "get-blob-duration";
import { useMemo } from "react";
import QcastApi from "../../api/api-qcast";

const ReviewResponse = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;
  const {
    recordedVideoData: videoWithData,
    recordedVideo: recorded,
    thumbnail,
    title,
    tag,
    answerIndex,
  } = useSelector((store) => store.respond);
  const [tagNo, setAddTag] = useState(1);

  const rdDispatch = useDispatch();
  const [isSaving, setIsSaving] = useState(false);

  const currentQcast = useSelector((state) => state.qcast.currentQcast);
  const { userId, token } = useSelector((state) => state.auth);

  const [focusNextInput, setFocusNextInput] = useState(false);

  const { saveResponse } = QcastApi();

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [ansVidInfo, setAnsVidInfo] = useState({});
  const [quesVidInfo, setQuesVidInfo] = useState({});
  const ansVidRef = useRef(null);
  const quesVidRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const newVideo = {
      file: recorded,
      id: 1,
      transcript: "",
      duration: getBlobDuration(recorded),
    };
    if (!videoWithData) {
      rdDispatch({ type: "respond/saveVideoData", payload: newVideo });
    }

    Object.keys(tag).forEach((key, idx) => {
      if (tag[key] !== "") {
        setAddTag(idx + 2);
      }
    });

    // subscribe state change
    ansVidRef.current.subscribeToStateChange(handleStateChangeA);
    quesVidRef.current.subscribeToStateChange(handleStateChangeQ);
  }, []);

  useEffect(() => {
    if (quesVidInfo.waiting || ansVidInfo.waiting) {
      ansVidRef.current.pause();
      quesVidRef.current.pause();
    } else if (!quesVidInfo.waiting && !ansVidInfo.waiting && isPlaying) {
      if (ansVidInfo.ended) {
        setIsPlaying(false);
        return;
      }
      ansVidRef.current.play();
      if (quesVidInfo.ended) {
        ansVidRef.current.muted = false;
      } else {
        ansVidRef.current.muted = true;
        quesVidRef.current.play();
      }
    }

    if (
      currentQcast &&
      !quesVidInfo.waiting &&
      !ansVidInfo.waiting &&
      currentQuestion !== answerIndex.length - 1 &&
      answerIndex.length > 0
    ) {
      let ansIndexes = answerIndex;
      if (
        Math.round(ansIndexes[currentQuestion] / 1000) ===
        Math.round(ansVidInfo.currentTime)
      ) {
        ansVidRef.current.seek(ansIndexes[currentQuestion] / 1000);
        setCurrentQuestion(currentQuestion + 1);
      }
    }
  }, [ansVidInfo, quesVidInfo]);

  const handleStateChangeA = (state) => {
    // copy player state to this component's state
    setAnsVidInfo(state);
  };
  const handleStateChangeQ = (state) => {
    // copy player state to this component's state
    setQuesVidInfo(state);
  };

  const newTag = (idx) => {
    return (
      <input
        className="text-xs h-[2rem] text-center rounded-md bg-[#FFFFFF80] shadow-sm w-full"
        placeholder="Add tag"
        key={idx}
        disabled={idx + 1 < tagNo}
        value={tag[idx]}
        autoFocus={focusNextInput && idx + 1 === tagNo}
        onChange={(e) =>
          rdDispatch({
            type: "respond/setTag",
            payload: { type: "add", pos: idx, value: e.target.value },
          })
        }
        onKeyDown={(e) => {
          e = e || window.event;
          if (e.key === "Enter" || e.keyCode === 13 || e.code === "Enter") {
            if (tagNo <= 5 && tag[idx].length > 0) {
              setFocusNextInput(true);
            }
            setAddTag((prev) => prev + 1);
          }
        }}
      />
    );
  };

  const save = () => {
    setIsSaving(true);

    const tags = tag.filter((item) => item !== "");

    const post = {
      response: videoWithData ? videoWithData.file : recorded,
      title,
      tag: tags,
      userId,
      qcastId: currentQcast.qcastId,
      responseThumbnail: thumbnail,
      questionList: currentQcast.listOfVideos
        .filter((_, idx) => idx <= currentQcast.currentVidIndex)
        .map((vd) => vd.split("/")[5]),
      answerIndex: answerIndex,
    };

    if (title && tags.length > 0 && videoWithData.file && thumbnail) {
      saveResponse(post, token, (res) => {
        if (res.id === 200) {
          props.proceed();
          rdDispatch({ type: "respond/reset" });
        } else {
          alert(res.msg);
          setIsSaving(false);
        }
      });
    } else {
      alert("Please fill all the field!");
      setIsSaving(false);
    }
  };

  const video = useMemo(() => {
    if (recorded) {
      return (
        <Player
          src={window.URL.createObjectURL(recorded)}
          className="rounded-full overflow-hidden m-auto"
          fluid={false}
          width={140}
          aspectRatio={"1:1"}
          ref={ansVidRef}
        >
          <ControlBar disableCompletely={true} className="my-class" />
        </Player>
      );
    }
    return null;
  }, [recorded]);

  const handlePlayingControl = () => {
    if (ansVidInfo.paused) {
      setIsPlaying(true);
      if (ansVidInfo.currentTime === ansVidInfo.duration || ansVidInfo.ended) {
        setCurrentQuestion(0);
      }
      ansVidRef.current.play();
      quesVidRef.current.play();
    } else {
      setIsPlaying(false);
      ansVidRef.current.pause();
      quesVidRef.current.pause();
    }
  };

  return (
    <div
      id="main-review"
      className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[15px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden"
    >
      <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 px-2 items-center py-2 shadow-sm">
        <button
          className="justify-self-start mr-2 w-[1.2rem] h-[1.5rem] lg:w-[1.5rem] aspect-square rounded-full bg-[#8DACCD54] flex flex-col "
          onClick={() => {
            rdDispatch({ type: "respond/reset" });
            rdDispatch({
              type: "qcast/currentQcast",
              payload: {
                currentVidIndex: 0,
              },
            });
            props.back();
          }}
          disabled={isSaving}
        >
          <IoArrowBack
            color="#2C3037"
            className="m-auto w-full text-xs lg:text-sm"
          />
        </button>
        <p className="font-medium w-fit justify-self-center text-[#1E3053] whitespace-nowrap">
          Review Response
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full px-2 md:px-4 flex flex-col space-y-3 items-center pt-4 pb-4">
        <span className="w-full flex flex-row space-x-8">
          <span
            id="respond-video-record"
            className="h-fit relative w-[150px] aspect-square"
          >
            <span className="w-[150px] h-[150px] relative bg-[#ECF5FC66] rounded-full flex aspect-square flex-col shadow-md">
              {recorded ? video : null}
            </span>
            <span className="h-1/2 w-1/2 absolute bottom-0 -right-4 shadow-md rounded-full flex flex-col aspect-square bg-[white]">
              <Player
                src={currentQcast.listOfVideos[currentQuestion]}
                className="rounded-full overflow-hidden m-auto"
                width={66}
                fluid={false}
                aspectRatio="1:1"
                ref={quesVidRef}
              >
                <ControlBar disableCompletely={true} className="my-class" />
              </Player>
            </span>
            <button
              onClick={handlePlayingControl}
              className="absolute bottom-3 left-[50%] transform -translate-x-1/2"
            >
              {isPlaying ? (
                <IoPause className="text-base text-white" />
              ) : (
                <IoPlay className="text-base text-white" />
              )}
            </button>
          </span>
          <div className="w-full h-full grid grid-cols-1 justify-between text-sm space-y-4">
            <button
              onClick={() => {
                rdDispatch({ type: "respond/trimVideo", payload: recorded });
                props.editresponse();
              }}
              style={{ color: bg }}
              className="bg-[#FFFFFFB2] rounded-md flex flex-row items-center justify-center space-x-1 text-xs py-1 shadow-sm"
              disabled={isSaving}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 21 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.4974 3.33774L16.5858 7.42608L6.23697 17.7749L2.15091 13.6866L12.4974 3.33774ZM19.6881 2.35173L17.8648 0.52847C17.1602 -0.176157 16.016 -0.176157 15.309 0.52847L13.5625 2.27497L17.6509 6.36335L19.6881 4.32615C20.2346 3.7796 20.2346 2.89824 19.6881 2.35173ZM0.011377 19.433C-0.0630262 19.7679 0.239299 20.0679 0.574189 19.9865L5.13 18.8819L1.04394 14.7936L0.011377 19.433Z"
                  fill={bg}
                />
              </svg>
              <p>Edit Response</p>
            </button>

            <span className="flex flex-row space-x-2 items-center">
              <button
                onClick={props.responsethumbnail}
                className="bg-[#FFFFFFB2] w-[3.1rem] h-[3.5rem] lg:w-[3.5rem] aspect-square flex flex-col rounded-full shadow-sm"
                disabled={isSaving}
              >
                {thumbnail ? (
                  <img
                    src={thumbnail}
                    className="w-[3.1rem] lg:w-[3.5rem] border-2 border-[#FFFFFF80] rounded-full m-auto object-cover"
                    alt="Thumbnail"
                  />
                ) : (
                  <IoAdd
                    color={bg}
                    className="text-[#97AAC3] m-auto text-2xl lg:text-3xl"
                  />
                )}
              </button>
              <p className="text-xs lg:text-sm">
                {thumbnail ? "Edit Thumbnail" : "Add Thumbnail"}
              </p>
            </span>
          </div>
        </span>
        <input
          onChange={(e) =>
            rdDispatch({ type: "respond/setTitle", payload: e.target.value })
          }
          value={title}
          disabled={isSaving}
          className="text-xs px-2 bg-[#FFFFFF80] w-full h-[2rem] rounded-lg shadow-sm"
          placeholder="Enter Response title"
        />
        <span className="flex flex-row items-center w-full">
          {Array(tagNo)
            .fill(newTag)
            .map((item, index) => {
              if (index <= 5 && index + 1 === tagNo) {
                return (
                  <span className="w-1/4 mr-1" key={index}>
                    {item(index)}
                  </span>
                );
              } else if (index <= 5) {
                return (
                  <span
                    onClick={(e) => {
                      console.log(e);
                      rdDispatch({
                        type: "respond/setTag",
                        payload: { type: "del", pos: index },
                      });
                      setAddTag((prev) => prev - 1);
                    }}
                    key={index}
                    className="text-xs h-[2rem] flex justify-center items-center rounded-[10px] shadow-sm w-1/4 mr-1"
                    style={{
                      background: bg,
                      color: font,
                      boxShadow:
                        "-1px -3px 5px rgba(255, 255, 255, 0.3), 5px 3px 10px rgba(0, 0, 0, 0.18)",
                    }}
                  >
                    {tag[index]}
                  </span>
                );
              }
              return <></>;
            })}
          {tagNo <= 5 && (
            <button onClick={() => setAddTag((prev) => prev + 1)}>
              <IoAdd color={bg} className="text-xl text-[#2E689D]" />
            </button>
          )}
        </span>
        <span className="flex flex-row w-[60%] gap-1">
          <button
            onClick={save}
            style={{ backgroundColor: bg, color: font }}
            disabled={isSaving}
            className="text-xs py-2 flex-grow w-full rounded-full p-1 shadow-md mt-4 relative"
          >
            {isSaving ? (
              <>
                {" "}
                Saving...{" "}
                <svg
                  className="h-3 w-3 absolute right-[12px] top-1/2 transform -translate-y-1/2"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 100 100"
                  preserveAspectRatio="xMidYMid"
                >
                  <circle
                    cx="50"
                    cy="50"
                    fill="none"
                    stroke="#ffffff"
                    strokeWidth="8"
                    r="45"
                    strokeDasharray="212.05750411731105 72.68583470577035"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      repeatCount="indefinite"
                      dur="1s"
                      values="0 50 50;360 50 50"
                      keyTimes="0;1"
                    ></animateTransform>
                  </circle>
                </svg>{" "}
              </>
            ) : (
              "Save"
            )}
          </button>
        </span>
      </div>
    </div>
  );
};

export default ReviewResponse;
